import {Component, Input} from '@angular/core';
import {LinkedExample} from '../../models/word.model';
import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';

@Component({
  selector: 'app-link-example',
  template: `
    <button type="button"
            class="link-example"
            [class.selected]="isSelected"
            (click)="onClick($event)">
      <div [innerHTML]="showLongVowels
        ? (example.example_t | rmSlash | resize | keepHtml)
        : (example.example_t | rmSlash | rmLongVowel | resize | keepHtml)"></div>
    </button>
  `,
  styleUrls: ['./link-example.component.scss'],
})
export class LinkExampleComponent {
  @Input() example: LinkedExample;
  @Input() showLongVowels = true;

  constructor(private lm: LayoutMgrService) {}

  get isSelected(): boolean {
    return this.lm.showLinkedExample
      && this.lm.linkedExample?.id === this.example?.id
      && this.lm.linkedExample?.example_t === this.example?.example_t;
  }

  onClick($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.lm.OpenLinkedExamplePopup(this.example);
  }
}
